/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDiscountCodeFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeDiscountCode, serializeGenerateCodesRequest, type DiscountCode, type ErrorResponse, type GenerateCodesRequest, type InternalErrorResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/campaigns/{campaignId}/codes/generate
 */
export interface GenerateRequestBuilder extends BaseRequestBuilder<GenerateRequestBuilder> {
    /**
     * Makes random codes for a code-triggered campaign: count of them with the prefix, or, when customerNumbers is given, one per listed customer with that code restricted to that customer. The random part uses an alphabet with no look-alike characters. Every option applies to every generated code. Export the result with the CSV endpoint.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DiscountCode[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: GenerateCodesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DiscountCode[] | undefined>;
    /**
     * Makes random codes for a code-triggered campaign: count of them with the prefix, or, when customerNumbers is given, one per listed customer with that code restricted to that customer. The random part uses an alphabet with no look-alike characters. Every option applies to every generated code. Export the result with the CSV endpoint.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: GenerateCodesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const GenerateRequestBuilderUriTemplate = "{+baseurl}/api/campaigns/{campaignId}/codes/generate";
/**
 * Metadata for all the requests in the request builder.
 */
export const GenerateRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: GenerateRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createDiscountCodeFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeGenerateCodesRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
